export default class GeometryUtilities {

    static centimeterForPixels(cm, ratio) {

        return cm * ratio;
    }

    static distance(a, b) {

        let distance = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
        return distance;
    }

    /*
        public static double slope(Point p1, Point p2) {

        double slope = (p2.y - p1.y) / (double)(p2.x - p1.x);

        return slope;
    }
    */

    static isBetween(a, c, b, delta) {

        let d1 = Math.round(GeometryUtilities.distance(a, c) + GeometryUtilities.distance(c, b));
        let d2 = Math.round(GeometryUtilities.distance(a, b));

        if (d2 + delta > d1 && d2 - delta < d1) return true;

        return false;
    }

    static rotatePointWithCenter(p, center, angle) {

        angle = angle * (Math.PI / 180);

        let x1 = p.x - center.x;
        let y1 = p.y - center.y;

        let x2 = x1 * Math.cos(angle) - y1 * Math.sin(angle);
        let y2 = x1 * Math.sin(angle) + y1 * Math.cos(angle);

        p = {

            x: x2 + center.x,
            y: y2 + center.y
        }

        return p;
    }

    static isPointInsideCircle(p, center, radius) {

        let distance = GeometryUtilities.distance(p, center);
        if (radius > distance) {
            return true;
        }

        return false;
    }

    static slope(p1, p2) {

        let slope = (p2.y - p1.y) / (p2.x - p1.x);
        return slope;
    }

    static angleBetweenTwoLines(l1, l2, variable, angle) {

        let l11 = l1[0], l12 = l1[1], l21 = l2[0], l22 = l2[1];


        l1.map(p => {

            if (variable[1] == p.label) l11 = p;
            else l12 = p;
        });

        l2.map(p => {

            if (variable[1] == p.label) l21 = p;
            else l22 = p;
        });

        let a1 = Math.atan2(l12.y - l11.y, l12.x - l11.x)  * 180 / Math.PI;
        let a2 = Math.atan2(l22.y - l21.y, l22.x - l21.x)  * 180 / Math.PI;

        console.log('angle = ', a1+a2);
        console.log('angle = ', a1-a2);
        console.log('angle = ', a2-a1);

        let possibleAngles = [];

        possibleAngles.push(( 360 - a1 ) - ( a2 ));
        possibleAngles.push(( 360 - a2 ) - ( a1 ));
        possibleAngles.push(( 360 - a1 ) + ( a2 ));
        possibleAngles.push(( 360 - a2 ) + ( a1 ));
        possibleAngles.push(a1-a2);
        possibleAngles.push(a2-a1);
        possibleAngles.push(Math.abs(a1) + a2);
        possibleAngles.push(Math.abs(a2) + a1);

        
        console.log(a1, " ", a2);
        angle = Math.abs(a1) - Math.abs(a2);

        return possibleAngles;

    }

}